export default "__VITE_ASSET__7zEB5DyG__"